export default __webpack_public_path__ + "static/cbt-a68ef135bfc4b467db032d33278a7c31.jpg";